import * as React from 'react';
import PropTypes from "prop-types";
import Link from "../../../components/Application/Link";
import {useTranslation} from "react-i18next";

function AddButton(props) {
  const { t } = useTranslation()

  return (
    <Link className="btn btn-primary d-flex flex-nowrap align-items-center" to={props.to}>
      <i className="fas fa-plus" />
      <span className="d-none d-sm-block ml-2">{props.btnText ?? t('common:btn.create')}</span>
    </Link>
  );
}

AddButton.propTypes = {
  to: PropTypes.string.isRequired,
  btnText: PropTypes.string,
};

export default AddButton;
